import { render } from "./PartnerWxBind.vue?vue&type=template&id=093cb24d&scoped=true"
import script from "./PartnerWxBind.vue?vue&type=script&lang=js"
export * from "./PartnerWxBind.vue?vue&type=script&lang=js"

import "./PartnerWxBind.vue?vue&type=style&index=0&id=093cb24d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093cb24d"],['__file',"src/components/h5/partner/PartnerWxBind.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "093cb24d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('093cb24d', __exports__)) {
    api.reload('093cb24d', __exports__)
  }
  
  module.hot.accept("./PartnerWxBind.vue?vue&type=template&id=093cb24d&scoped=true", () => {
    api.rerender('093cb24d', render)
  })

}


export default __exports__